import './three-boxes.scss';

/**
 * version    1.0
 * class      <type> (ThreeBoxes)
 * classdesc  Component that manage the three-boxes section
 */
export class ThreeBoxes {}
